/*
  The product cards' cart button and the header's cart counter. Vanilla,
  all pages (layout/theme.liquid, defer). Styles: assets/product-card.css
  (the button) and assets/header.css (the counter).
  - The button: the one of the card grid (.cc-grid, product-grid-item.liquid,
    whose markup doesn't change: the onclick with Shopify.addItem), and the
    quick view's "Agregar al carrito" and "Comprar ahora"
    (sections/quick-view.liquid, the same onclick). On a
    click, .is-loading (a spinner) until the piece is added, then .is-added
    (a check) for 1 second. While loading, more clicks don't reach the
    onclick (listened in capture, before it), so nothing is added twice. On
    an error (no more stock, anything else), .is-error for 1.2 seconds (dark
    red and a short shake), then back to normal, and the notice (below).
    Only with "Ajax Popup Cart" (the one the store uses): "Ajax Spin Cart"
    has its own states, and "Without Ajax Cart" is a form that reloads.
  - When it's added or fails: jQuery's global ajax events (ajaxSuccess,
    ajaxError) for /cart/add.js, which Shopify.addItem asks with jQuery.ajax,
    matched by the variant id of the request. Nothing in cart.api.js or
    mini-cart.js changes.
  - The counter (.header-count .bigcounter, desktop and mobile headers):
    a short bump when its number changes, whoever changes it (cart.api.js's
    Shopify.cartUpdateInfo, also from the mini cart and the cart page).
  - The notice when a piece can't be added (snippets/cart-notice.liquid):
    instead of cart.api.js's window (#modalAddToCartError), which nothing
    opens any more. Shopify.onError (its callers: Shopify.addItem, so the
    cards, the comparator's "Carrito" and the quick view) is replaced here,
    after cart.api.js; anything else that adds without it gets the notice
    from ajaxError for /cart/add.js, once per request (xhr.cartNoticeShown).
    With a modal <dialog> open that has a place for it
    ([data-cart-notice-slot]: the quick view), the message goes there: the
    rest of the page is inert under the dialog, so the notice wouldn't
    show, nor be read.
    The product page has its own message below the button
    (product-cart-action.liquid marks its requests). 422 (no more stock):
    the stock text; anything else, the other one. 5 seconds, paused while
    the mouse or the focus is on it; "Ver carrito" opens the mini cart.
*/
(function () {
  'use strict';

  var BUTTONS = '.cc-grid .cart-hover .btn-cart[onclick]:not(.ajax-spin-cart), [data-qv-add][onclick], [data-qv-buy][onclick]';
  var ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
  var ADDED_MS = 1000;
  var ERROR_MS = 1200;
  var TIMEOUT_MS = 15000; // no answer at all: back to normal
  var NOTICE_MS = 5000;
  var $ = window.jQuery;

  function variantOf(button) {
    var match = /addItem\(\s*(\d+)/.exec(button.getAttribute('onclick') || '');
    return match ? match[1] : '';
  }

  function reset(button) {
    window.clearTimeout(button.cartTimer);
    button.classList.remove('is-loading', 'is-added', 'is-error');
    button.removeAttribute('aria-busy');
  }

  // ---- The cards' button -----------------------------------------------------

  if ($) {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(BUTTONS);
      if (!button) return;
      if (button.classList.contains('is-loading')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      reset(button);
      hideSlot(button);
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.cartTimer = window.setTimeout(function () { reset(button); }, TIMEOUT_MS);
    }, true);

    var settle = function (settings, ok) {
      if (!settings || !ADD_URL.test(settings.url || '')) return;
      var match = /(?:^|&)id=(\d+)/.exec(typeof settings.data === 'string' ? settings.data : '');
      var id = match ? match[1] : '';
      Array.prototype.forEach.call(document.querySelectorAll(BUTTONS), function (button) {
        if (!button.classList.contains('is-loading')) return;
        if (id && variantOf(button) !== id) return;
        reset(button);
        button.classList.add(ok ? 'is-added' : 'is-error');
        button.cartTimer = window.setTimeout(function () { reset(button); }, ok ? ADDED_MS : ERROR_MS);
      });
    };

    $(document).on('ajaxSuccess', function (event, xhr, settings) { settle(settings, true); });
    $(document).on('ajaxError', function (event, xhr, settings) {
      settle(settings, false);
      if (settings && ADD_URL.test(settings.url || '') && !(xhr && xhr.cartNoticeShown)) showNotice(xhr);
    });
  }

  // ---- The notice when a piece can't be added ---------------------------------

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var noticeTimer = 0;
  var hideTimer = 0;

  function noticeBox() {
    return document.querySelector('[data-cart-notice]');
  }

  // Below the header that's on screen (mobile or desktop, fixed or not)
  function headerBottom() {
    var bottom = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.site-header-m, .site-header__main'), function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.height) bottom = Math.max(bottom, rect.bottom);
    });
    return Math.max(0, bottom);
  }

  function hideNotice() {
    var box = noticeBox();
    window.clearTimeout(noticeTimer);
    if (!box || box.hidden) return;
    box.classList.remove('is-shown');
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () { box.hidden = true; }, reduceMotion ? 0 : 250);
  }

  function countDown() {
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(hideNotice, NOTICE_MS);
  }

  // The place for the message in an open modal <dialog> (the quick view)
  function dialogSlot() {
    var slots = document.querySelectorAll('dialog[open] [data-cart-notice-slot]');
    return slots.length ? slots[slots.length - 1] : null;
  }

  // A new try from a button in a dialog: its last message goes away
  function hideSlot(button) {
    var d = button.closest('dialog');
    var slot = d && d.querySelector('[data-cart-notice-slot]');
    if (slot) slot.hidden = true;
  }

  function showNotice(xhr) {
    if (xhr) xhr.cartNoticeShown = true;
    var box = noticeBox();
    if (!box) return false;
    var text = box.getAttribute(xhr && xhr.status === 422 ? 'data-stock' : 'data-error') || '';
    var slot = dialogSlot();
    if (slot) {
      var line = slot.querySelector('[data-cart-notice-slot-text]') || slot;
      line.textContent = '';
      slot.hidden = false;
      window.setTimeout(function () { line.textContent = text; }, 50);
      return true;
    }
    box.querySelector('[data-cart-notice-text]').textContent = text;
    box.style.top = (headerBottom() + 8) + 'px';
    window.clearTimeout(hideTimer);
    box.hidden = false;
    void box.offsetWidth; // shown first, then the slide
    box.classList.add('is-shown');
    var status = document.querySelector('[data-cart-notice-status]');
    if (status) {
      status.textContent = '';
      window.setTimeout(function () { status.textContent = text; }, 50);
    }
    countDown();
    return true;
  }

  // Paused while the mouse or the focus is on it (its link can be reached)
  document.addEventListener('mouseover', function (event) {
    if (event.target.closest && event.target.closest('[data-cart-notice]')) window.clearTimeout(noticeTimer);
  });
  document.addEventListener('mouseout', function (event) {
    var box = noticeBox();
    if (box && !box.hidden && box.contains(event.target) && !box.contains(event.relatedTarget)) countDown();
  });
  document.addEventListener('focusin', function (event) {
    if (event.target.closest && event.target.closest('[data-cart-notice]')) window.clearTimeout(noticeTimer);
  });
  document.addEventListener('focusout', function (event) {
    var box = noticeBox();
    if (box && !box.hidden && box.contains(event.target) && !box.contains(event.relatedTarget)) countDown();
  });

  // "Ver carrito" (the notice's and the quick view's): the mini cart (the
  // quick view closes first); without it, the link goes to the cart page
  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-cart-notice-view]')) return;
    if (!(window.MiniCart && typeof MiniCart.open === 'function')) return;
    if (window.QuickView) QuickView.close(true);
    if (MiniCart.open()) {
      event.preventDefault();
      hideNotice();
    }
  });

  // After cart.api.js (this file is defer): its window no longer opens
  if (window.Shopify && typeof Shopify.onError === 'function') {
    var oldOnError = Shopify.onError;
    Shopify.onError = function (xhr) {
      if (!showNotice(xhr)) return oldOnError.apply(this, arguments);
    };
  }

  // ---- The header's counter --------------------------------------------------

  function watch(counter) {
    if (counter.cartWatched) return;
    counter.cartWatched = true;
    var last = counter.textContent.trim();
    new MutationObserver(function () {
      var now = counter.textContent.trim();
      if (now === last) return;
      last = now;
      var pill = counter.closest('.header-count') || counter;
      pill.classList.remove('is-bump');
      void pill.offsetWidth; // restart it if it's running
      pill.classList.add('is-bump');
      pill.addEventListener('animationend', function () { pill.classList.remove('is-bump'); }, { once: true });
    }).observe(counter, { childList: true, characterData: true, subtree: true });
  }

  function watchAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.header-count .bigcounter'), watch);
  }

  watchAll();
  // Theme editor: the header drawn again
  document.addEventListener('shopify:section:load', watchAll);
})();
